import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1300Model } from '../kymw1300.model';
import { KYMW1300GetSearchSelectedListModel } from '../vo/kymw1300-get-search-selected-list.model';

/**
 * 商品企画マスタ画面　選定済一覧を取得するサービス
 *
 * @export GetSelectedListService
 * @class GetSelectedListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSelectedListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof GetSelectedListService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof GetSelectedListService
   */
  private vo: KYMW1300GetSearchSelectedListModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetSelectedListService
   */
  private successFunc: (model: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSelectedListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        DispMode: this.vo.dispMode,
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        SellAreaCode: this.vo.sellAreaCode,
        OrderNumQuotaCode: this.vo.orderNumQuotaCode,
        CoopCode: this.vo.coopCode,
        ClassCode: this.vo.classCode,
        MiddleClassCode: this.vo.middleClassCode,
        SmallClassCode: this.vo.smallClassCode,
        PageNo: this.vo.pageNo,
        BuyerCode: this.vo.buyerCode,
        NextGuideCheck: this.vo.nextGuideCheckFlg,
        Page: this.vo.page,
        SortItem: this.vo.sortItem,
        SortOrder: this.vo.sortOrder,
        OrdrClientCode: this.vo.orderClientCode,
        OrdrClientKanji: this.vo.orderClientKanji,
        PayeeClientCode: this.vo.payeeClientCode,
        PayeeClientKanji: this.vo.payeeClientKanji,
        KikakuRenrakuStatus: this.vo.kikakuRenrakuStatus
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSelectedListService
   */
  execute(model: KYMW1300Model, vo: KYMW1300GetSearchSelectedListModel, successFunc: (model: any) => void): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getSelectedList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSelectedListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
